import { FormlyFieldConfig } from '@ngx-formly/core';
import type { FormlyHookFn } from './formly-hook-fn.type';
import { getChildObject } from './form-data.utility';
import { switchMap, takeUntil } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';

export const prefillESSDetailsHook = (sharedEss$, destroyed$): FormlyHookFn => {
  return (field: FormlyFieldConfig) => {
    const p = field.parent;
    const mfgObj = getChildObject(p, 'essManufacturer');
    const mfgFormField = field.form.get(mfgObj.key);

    // Clear all fields when manufacturer changes
    mfgFormField?.valueChanges
      .pipe(takeUntil(destroyed$))
      .subscribe(() => {
        field.formControl.setValue('');

        const typeObj = getChildObject(p, 'essType');
        if (typeObj) field.form.get(typeObj.key)?.setValue('');

        const capRatingObj = getChildObject(p, 'essCapacityRating');
        if (capRatingObj) field.form.get(capRatingObj.key)?.setValue('');

        const energyCapObj = getChildObject(p, 'essEnergyCapacity');
        if (energyCapObj) field.form.get(energyCapObj.key)?.setValue('');

        const nomVoltObj = getChildObject(p, 'essNominalVoltage');
        if (nomVoltObj) field.form.get(nomVoltObj.key)?.setValue('');

        const maxDisObj = getChildObject(p, 'essMaxDischargeRate');
        if (maxDisObj) field.form.get(maxDisObj.key)?.setValue('');

        // Re-enable "Other" fields
        const mfgOtherObj = getChildObject(p, 'other_manufacturer');
        if (mfgOtherObj) field.form.get(mfgOtherObj.key)?.enable();

        const modelOtherObj = getChildObject(p, 'other_model');
        if (modelOtherObj) field.form.get(modelOtherObj.key)?.enable();
      });

    field.formControl.valueChanges
      .pipe(
        switchMap((val) => {
          return forkJoin<[any, any]>([of(val), sharedEss$]);
        }),
        takeUntil(destroyed$)
      )
      .subscribe(([modelNum, ess]) => {
        if (modelNum) {
          const currEss = ess.find((Ess) => {
            return Ess.modelNumber === modelNum;
          });
          if (currEss) {
            (field.form.controls as any).capacity?.setValue(
              currEss.nameplateEnergyCapacity
            );

            const typeObj = getChildObject(p, 'essType');
            if (typeObj)
              field.form.get(typeObj.key)?.setValue(currEss.technology);

            const capRatingObj = getChildObject(p, 'essCapacityRating');
            if (capRatingObj)
              field.form
                .get(capRatingObj.key)
                ?.setValue(currEss.nameplatePower);

            const energyCapObj = getChildObject(p, 'essEnergyCapacity');
            if (energyCapObj)
              field.form
                .get(energyCapObj.key)
                ?.setValue(currEss.nameplateEnergyCapacity);

            const nomVoltObj = getChildObject(p, 'essNominalVoltage');
            if (nomVoltObj)
              field.form.get(nomVoltObj.key)?.setValue(currEss.nominalVoltage);

            const maxDisObj = getChildObject(p, 'essMaxDischargeRate');
            if (maxDisObj)
              field.form
                .get(maxDisObj.key)
                ?.setValue(currEss.maximumContinuousDischargeRate);

            // Disable "Other" fields when pre-filling
            const mfgOtherObj = getChildObject(p, 'other_manufacturer');
            if (mfgOtherObj) {
              field.form.get(mfgOtherObj.key)?.disable();
            }

            const modelOtherObj = getChildObject(p, 'other_model');
            if (modelOtherObj) {
              field.form.get(modelOtherObj.key)?.disable();
            }
          }
        }
      });
  };
};
